import React, { useEffect, useState } from "react";
import { api, fmtDateTime } from "@/lib/api";
import { PageHeader, Card, Empty } from "@/components/admin/ui";

const CATS = [["", "All activity"], ["pii", "Private details viewed"], ["cases", "Case & application changes"], ["reports", "Reports & billing"], ["emails", "Emails sent"], ["signins", "Sign-ins"], ["codes", "Codes & orders"], ["orgs", "Organizations & paper forms"]];

export default function AuditLog() {
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("");
  const [items, setItems] = useState<any[]>([]);
  useEffect(() => {
    const t = setTimeout(() => api.get("/admin/audit", { params: { q: q || undefined, category: cat || undefined } }).then((r) => setItems(r.data)), 250);
    return () => clearTimeout(t);
  }, [q, cat]);
  return (
    <div>
      <PageHeader title="Activity history" subtitle="Who viewed private details, changed cases, generated reports, sent emails and signed in (latest 500)." />
      <div className="mb-5 flex flex-wrap gap-3">
        <select className="field-input max-w-xs" value={cat} onChange={(e) => setCat(e.target.value)} data-testid="audit-category-select">
          {CATS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
        <input className="field-input max-w-sm" placeholder="Filter by action, user or record ID…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="audit-search-input" />
      </div>
      <Card>
        {items.length ? (
          <div className="overflow-x-auto">
            <table className="tbl" data-testid="audit-table">
              <thead><tr><th>When</th><th>Action</th><th>User</th><th>Record</th><th>Details</th><th>IP</th></tr></thead>
              <tbody>
                {items.map((a) => (
                  <tr key={a.id}>
                    <td className="whitespace-nowrap text-xs">{fmtDateTime(a.at)}</td>
                    <td className={`font-mono text-[12px] font-semibold ${/pii/.test(a.action) ? "text-[#C2410C]" : "text-[#1B365D]"}`}>{a.action}</td>
                    <td className="text-xs">{a.actor_email}</td>
                    <td className="font-mono text-[11px] text-[#64748B]">{a.entity_type}{a.entity_id ? ` · ${String(a.entity_id).slice(0, 8)}` : ""}</td>
                    <td className="max-w-xs truncate font-mono text-[11px] text-[#64748B]" title={JSON.stringify(a.details)}>{Object.keys(a.details || {}).length ? JSON.stringify(a.details) : ""}</td>
                    <td className="text-xs text-[#94A3B8]">{a.ip}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : <Empty text="No audit entries." />}
      </Card>
    </div>
  );
}
